import { a as m, B as C } from "./chunk-BaseElement-CJM6sCUz.js";
import { d as f, O as b } from "./chunk-debounce-Bk6yKvzA.js";
import { W as u } from "./chunk-WithShopifyCart-BrHwaVIT.js";
import { t as p } from "./chunk-custom-element-CN0MC8o7.js";
import { x as E } from "./chunk-lit-element-D3OkYgeM.js";
import { n as _ } from "./chunk-property---aaewZr.js";
import "./chunk-quantity-input-DA_bttWz.js";
import { f as A } from "./chunk-firstFocusableElement-B5e7Zq7o.js";
import { a as g } from "./chunk-gqlOperations-D4wOnjh5.js";
import { H as v } from "./chunk-HTMLUpdateUtility-pt0dDGgp.js";
import { W as S } from "./chunk-WithApiClient-Da1nY1F5.js";
import { e as y } from "./chunk-query-DDwcON_0.js";
var O = Object.getOwnPropertyDescriptor, T = (e, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? O(t, i) : t, s = e.length - 1, a; s >= 0; s--)
    (a = e[s]) && (r = a(r) || r);
  return r;
};
let h = class extends u(
  m
) {
  constructor() {
    super(), this._handleInput = this._handleInput.bind(this), this._handleInputDebounced = f(
      this._handleInput,
      b
    );
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("input", this._handleInputDebounced);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("input", this._handleInputDebounced);
  }
  _handleInput(e) {
    const t = e.target.value;
    this.updateCartNoteAndAttributes({ note: t }, { sections: !1 });
  }
};
h = T([
  p("cart-note")
], h);
var w = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, I = (e, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? $(t, i) : t, s = e.length - 1, a; s >= 0; s--)
    (a = e[s]) && (r = (n ? a(t, i, r) : a(r)) || r);
  return n && r && w(t, i, r), r;
};
let c = class extends u(C) {
  _handleClick(e) {
    e.preventDefault(), this.key && this.removeItemFromCart(this.key);
  }
  render() {
    return E` <slot @click=${this._handleClick}></slot> `;
  }
};
I([
  _({ type: String })
], c.prototype, "key", 2);
c = I([
  p("cart-remove-toggle")
], c);
var D = Object.defineProperty, U = Object.getOwnPropertyDescriptor, l = (e, t, i, n) => {
  for (var r = n > 1 ? void 0 : n ? U(t, i) : t, s = e.length - 1, a; s >= 0; s--)
    (a = e[s]) && (r = (n ? a(t, i, r) : a(r)) || r);
  return n && r && D(t, i, r), r;
};
let o = class extends u(
  S(m)
) {
  constructor() {
    super(...arguments), this.$htmlUpdateUtility = new v(this), this.cart = window.__CART__;
  }
  connectedCallback() {
    super.connectedCallback(), this.addItem = this.addItem.bind(this), this._addItemDebounced = f(this.addItem, b), this.$htmlUpdateUtility.addPostProcessCallback(() => {
      var e, t;
      (t = (e = window == null ? void 0 : window.Shopify) == null ? void 0 : e.PaymentButton) == null || t.init(), this.lastFocusedElementSelectorId && setTimeout(() => {
        var n;
        const i = document.querySelector(
          `#${this.lastFocusedElementSelectorId}`
        );
        i ? i == null || i.focus() : (n = A(this)) == null || n.focus(), this.lastFocusedElementSelectorId = null;
      }, 50), this.prepareUpsells();
    }), this.prepareUpsells();
  }
  prepareUpsells() {
    if (!this.upsellElement)
      return;
    JSON.parse(
      this.upsellElement.getAttribute("data-upsell-ids") || "[]"
    ).forEach((t) => {
      this.getSection(t);
    });
  }
  async getSection(e) {
    const t = this.upsellElement.getAttribute("data-section-id"), i = this.upsellElement.getAttribute("data-base-url"), n = this.upsellElement.getAttribute("data-intent") || "complementary";
    if (!t || !i)
      return;
    const r = `${i}?product_id=${e}&limit=4&intent=${n}&section_id=${t}`;
    fetch(r, {
      method: "GET"
    }).then((s) => s.text()).then((s) => {
      const d = new DOMParser().parseFromString(s, "text/html").getElementById(
        `shopify-section-${t}`
      );
      this.upsellElement.innerHTML = this.upsellElement.innerHTML + (d == null ? void 0 : d.innerHTML);
    }).then(() => {
      var s, a;
      this.upsellElement.innerHTML.length > 0 ? (s = this.upsellElement.parentElement) == null || s.setAttribute("data-loaded", "true") : (a = this.upsellElement.parentElement) == null || a.setAttribute("data-loaded", "false"), this.hydrateAddToCart();
    }).catch((s) => {
      console.error(s);
    });
  }
  hydrateAddToCart() {
    this.querySelectorAll("[data-upsell-add]").forEach((e) => {
      e.removeEventListener("click", this._addItemDebounced), e.addEventListener("click", this._addItemDebounced);
    });
  }
  addItem(e) {
    if (!e.target)
      return;
    const t = e.target, i = t.getAttribute("data-upsell-add");
    if (!i)
      return;
    const r = [{
      id: i,
      quantity: 1
    }];
    t.setAttribute("disabled", "true"), t.setAttribute("aria-disabled", "true"), this.addItemToCart(r).then(() => {
      t.removeAttribute("disabled"), t.removeAttribute("aria-disabled");
    });
  }
  updateAttributes(e) {
    if (!this.cart || !e) return;
    const t = this.cart.attributes, i = e ? e.includes(",") ? e.split(",").map((s) => s.trim()) : [e] : [];
    if (!i.some(
      (s) => s in t
    )) return;
    const r = Object.fromEntries(
      Object.entries(t).map(([s, a]) => [
        s,
        i.includes(s) ? "" : a
      ])
    );
    this.updateCartNoteAndAttributes(
      {
        attributes: r
      },
      {
        sections: !0
      }
    );
  }
  async clearBuyerIdentity() {
    this.cart.token || (this.cart = await this.getCart());
    const e = {
      preferences: {
        delivery: {
          deliveryMethod: null,
          pickupHandle: null
        }
      }
    };
    if (!await this.$api.client.storefront({
      body: {
        query: g,
        variables: {
          id: `gid://shopify/Cart/${this.cart.token}`,
          buyerIdentity: e
        }
      }
    }))
      throw new Error("No data returned from API");
  }
  updated() {
    var e;
    if (this.cartSections[this.sectionId] && JSON.stringify(this.cartSections[this.sectionId]) !== o.SECTIONS_CACHE[this.sectionId]) {
      this.cart = window.__CART__, o.SECTIONS_CACHE[this.sectionId] = JSON.stringify(
        this.cartSections[this.sectionId]
      );
      const t = this.$htmlUpdateUtility.parseSectionStringForSelector(
        this.cartSections[this.sectionId],
        "#cart-drawer-render-target"
      );
      if (t && this.$htmlUpdateUtility.replace(this.sectionRenderTarget, t), t != null && t.hasAttribute("data-empty")) {
        const i = ((e = t.getAttribute("data-empty-attributes")) == null ? void 0 : e.trim()) || null;
        this.updateAttributes(i), this.clearBuyerIdentity();
      }
    }
  }
};
o.SECTIONS_CACHE = {};
l([
  _({ type: String, attribute: "section-id" })
], o.prototype, "sectionId", 2);
l([
  y("#cart-drawer-render-target")
], o.prototype, "sectionRenderTarget", 2);
l([
  y("[data-upsell-ids]")
], o.prototype, "upsellElement", 2);
o = l([
  p("cart-sections")
], o);
export {
  o as CartSections
};
